import {
  useBjelinTranslations,
  useProductTranslations
} from "../../hooks/TranslationHooks";
import "./style.scss";
import { productIsPurchasable, useProductUrl } from "../../utils/ProductUtils";
import FormattedPrice from "../FormattedPrice";
import BjelinButton from "../BjelinButton";
import ProductPurchaseColumn from "../ProductPurchaseColumn";
import { useCurrentUser } from "../../functional-components/UserContext";
import { useNavigate } from "react-router-dom";
import { useProductPrice } from "../../hooks/ProductHooks";

const GuideProductInfo = ({ product, large = false }) => {
  const { b2b } = useCurrentUser();
  const t = useBjelinTranslations();
  const tp = useProductTranslations();
  const navigate = useNavigate();
  const url = useProductUrl(product);

  const {
    hasPrice,
    unitPrice,
    priceUnit,
    isPerSquareMeter,
    hasPreviousPrice,
    previousPrice,
    currency,
    unitDisplayPrice,
    displayPrice
  } = useProductPrice(product, b2b);

  //if (product) console.log("product", product);

  return large ? (
    <ProductPurchaseColumn sku={product.sku} />
  ) : (
    productIsPurchasable(product, b2b) && (
      <div className="guide-product-info">
        {!b2b && hasPrice && (
          <div className={"price"}>
            {isPerSquareMeter && !!unitPrice ? (
              <FormattedPrice
                price={unitDisplayPrice}
                price_unit={priceUnit}
                currency={currency}
              />
            ) : (
              <FormattedPrice
                price={displayPrice}
                sales_unit={priceUnit}
                currency={currency}
              />
            )}
          </div>
        )}
        {!b2b && hasPreviousPrice && (
          <div className={"previous-unit-price"}>
            {tp("previous_unit_price")}
            <FormattedPrice price={previousPrice} currency={currency} />
          </div>
        )}
        <BjelinButton
          color="primary"
          block={false}
          lg={false}
          icon="chevron-right"
          onClick={e => {
            navigate(url);
            e.stopPropagation();
          }}
          className="info-btn"
        >
          <span className="btn-label">{t("more.info")}</span>
        </BjelinButton>
      </div>
    )
  );
};

export default GuideProductInfo;
